var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trackers"},[_vm._v(" x "),_vm._l((_vm.active_trackers),function(t){return _c('div',{staticClass:"single-tracker small text-secondary"},[_vm._v(" ["+_vm._s(t.version)+"]"+_vm._s(t.sid)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }